<template>
  <div class="wrapper" v-loading="loading">
    <v-head></v-head>
    <v-sidebar></v-sidebar>
    <div class="content-box" :class="{ 'content-collapse': collapse }">
      <v-tags></v-tags>
      <div class="content">
        <transition name="moveCartoon" appear>
          <keep-alive :include="tagsList">
            <router-view></router-view>
          </keep-alive>
        </transition>
        <el-backtop target=".content"></el-backtop>
      </div>
    </div>
  </div>
</template>

<script>
import vHead from './Header.vue';
import vSidebar from './Sidebar.vue';
import vTags from './Tags.vue';
import bus from "@/vuex/eventBus";
import { WebsocketServerUrl } from "../../utils/request.js";
export default {
  data() {
    return {
      tagsList: [],
      collapse: false,
      interval: null,
      alarmlogNum: 0,
      reConnectNum: 0, //websoocket 连接次数
      groupId: "",
      uerName: "",
      userId: "",
      websock: null,
      alertInterval:null,
      webSocketInterval:null, //websocket 心跳包
      loading: false,

    };
  },
  components: {
    vHead,
    vSidebar,
    vTags
  },
  methods: {
    getAdminToken() {
      var loginParams = {
        account: window.sessionStorage.getItem("username"),
        adminUser: window.sessionStorage.getItem("au"),
        adminPsd: window.sessionStorage.getItem("ap"),
      };
      this.$postHeadJson("uac/outAdmin/login", loginParams).then((response) => {
        window.sessionStorage.removeItem("au");
        window.sessionStorage.removeItem("ap");
        console.log(response);
        window.sessionStorage.setItem(
          "Authorization",
          "Bearer " + response.result.accessToken
        );
      });
    },
    getToken() {
      var loginParams = {
        username: window.sessionStorage.getItem("username"),
        password: window.sessionStorage.getItem("password"),
      };
      this.$postLogin("uac/auth/form", loginParams).then((response) => {
        window.sessionStorage.setItem(
          "Authorization",
          "Bearer " + response.access_token
        );
      });
    },
    getUserData() {
      this.$postForm("uac/user/getInformation", {}).then((response) => {
        this.groupId = response.result.groupId; //by guo 2020-3-23-13:34添加
        sessionStorage.setItem("groupId", response.result.groupId);
        this.uerName = response.result.userName;
        sessionStorage.setItem("userId", response.result.userId); //by guo 2020-1-21-14:56注释
        sessionStorage.setItem("uerName", response.result.userName);
        sessionStorage.setItem("roleCode", response.result.role);
        localStorage.setItem("groupPic", response.result.groupPic);
        sessionStorage.setItem("groupType", response.result.groupType);
        if(response.result.groupType == 6 || response.result.groupType == 3){
          bus.$emit("uerName", response.result.groupName);
        }else{
          bus.$emit("uerName", this.uerName);
        }
        this.userId = response.result.userId;
        this.initWebSocket();
        this.initAlertTime();
      });
    },
    geteventBusMshJump(msg) {
      if (msg.type == "jump") {
        if (this.$route.path != msg.path) {
          this.$router.push({
            path: msg.path,
            params: msg.params,
            query: msg.params
          });
        }
      } else if (msg.type == "alartMsgChange") {
        //详情页处理报警后首页刷新数据
        this.getAlarmlogDetail();
      }
    },
    //获取未处理的报警信息 获取数量
    getAlarmlogDetail() {
      this.$postJson("dmc/alert/queryDeviceAlertListWithPage", {
        pageNum: 1,
        isHandle: 0,
        pageSize: 1,
      }).then((res) => {
        if (res.code == 100010) {
          this.$message({ message: res.message, type: "error" });
          this.$router.push({ path: "/login" });
        }
        this.alarmlogNum = Number(res.result.total);
        bus.$emit("alertNumber", this.alarmlogNum);
      });
    },
    playLocalAudio(){
      var audio = new Audio();
      var url = require("../../assets/voice/notice.mp3");
      audio.src = url;
      audio.play();
    },
    playLocalNewOrderAudio(){
      var audio = new Audio();
      var url = require("../../assets/voice/new_order.mp3");
      audio.src = url;
      audio.play();
    },
    //判断是否还有未处理的报警// 开启循环 继续播放
    // 仅支持jhfly
    initAlertTime(){
      // 仅支持jhfly
      if(this.groupId == '1655'){
        let that = this;
        this.alertInterval = setInterval(() => {
          //查询最新的一条未处理的告警信息
          that.getAlarmlogNumber();
        }, 1 * 60 * 1000);
      }
    },
    getAlarmlogNumber() {
      this.$postJson("dmc/alert/queryDeviceAlertListWithPage", {
        pageNum: 1,
        isHandle: 0,
        pageSize: 1,
      }).then((res) => {
        if(Number(res.result.total)>0){
          this.playLocalAudio();
        }
      });
    },
    showNewOrder(info){
      console.log(info);
      if(info == null || info.length<10){
        return;
      }
      let newOrderInfo = JSON.parse(info);
      let msg = '<div>' +
          '<p>' + newOrderInfo.message + '</p>' +
          '</div>'
      this.$notify({
          title: '新订单',
          message: msg,
          duration: 3000,
          onClick: () => {
            this.$router.push({
              path: "/ServiceWorkOrder",
            });
          },
          dangerouslyUseHTMLString: true,
          type: 'warning'
      });

      this.playLocalNewOrderAudio();
    },
    showAlertInfo(info){
      if(info == null || info.length<10){
        return;
      }
      let alertInfo = JSON.parse(info);
      let msg = '<div>' +
        '<p>发生位置:  ' + alertInfo.location + '</p>' +
        '<p>告警信息:  ' + alertInfo.info + '</p>' +
        '</div>'
      if (alertInfo.oldmanName) {
        msg = '<div>' +
          '<p>长者姓名:  ' + alertInfo.oldName + '</p>' +
          '<p>发生位置:  ' + alertInfo.location + '</p>' +
          '<p>告警信息:  ' + alertInfo.info + '</p>' +
          '</div>'
      }
      this.playLocalAudio();
      this.$notify({
        title: '设备告警',
        message: msg,
        duration: 3000,
        dangerouslyUseHTMLString: true,
        type: 'warning'
      });

    },
    //跳转到报警记录 by xiang
    jumpAlarmlog() {
      bus.$emit("homePage", {
        type: "jump",
        path: "/alarmlog",
        title: "告警记录",
      });
    },
    //初始化weosocket
    initWebSocket() {
      if ("WebSocket" in window) {
        if (this.groupId != null) {
          this.websock = new WebSocket(
            WebsocketServerUrl.webSocketServer + "/" + this.groupId
          );
          this.websock.onmessage = this.websocketonmessage;
          this.websock.onerror = this.websocketonerror;
          this.websock.onclose = this.websocketclose;
          let that = this;
          this.webSocketInterval = setInterval(() => {
            that.websock.send("open");
          }, 1 * 60 * 1000);

        }
      } else {
        this.$message({
          message:
            "当前浏览器不支持使用websocket，建议使用chrome或者火狐浏览器！",
          type: "error"
        });
      }
    },
    //报错时
    websocketonerror() {
      //连接建立失败重连
      if (this.reConnectNum < 3) {
        setTimeout(() => {
          this.initWebSocket();
          this.reConnectNum = this.reConnectNum + 1;
        }, 1000);
      }
    },
    //关闭时
    websocketclose(ev) {
      //关闭
      if (
        this.reConnectNum < 3 &&
        this.userId != null &&
        this.websock.readyState == 3
      ) {
        setTimeout(() => {
          this.initWebSocket();
          this.reConnectNum = this.reConnectNum + 1;
        }, 1000);
      }
    },
    //接受到信息时
    websocketonmessage(ev) {
      //数据接收
      //通过后台返回的字段去判断
      if (ev.data) {
        if (ev.data == 'web_alert_refresh') {
          this.getAlarmlogDetail();
        //   this.$bus.$emit("changeHome_alarmLog"); //发送一个change事件 去改变报警记录页的
        //   this.$bus.$emit("changeSystemMain_websocket"); //发送一个change事件 去改变报警的铃铛图片的数据 以及图表页的报警数据
        //   this.$bus.$emit("changeLifeAlarm_websocket"); //life集团的报警通知刷新页面
        } else if (ev.data.indexOf('web_alert_add')!=-1) {
          //有报警发生
          this.showAlertInfo(ev.data);
        } else if (ev.data.indexOf('orderNews')!=-1) {
          // 来新订单了.
          this.showNewOrder(ev.data);
          this.$bus.$emit("orderNumber", ev.data);
          //处理了报警
        } else if (ev.data.indexOf('web_alert_hand')!=-1) {
          
          //处理了报警
        } else if (ev.data.indexOf('web_out_bed') != -1) {
          console.log(ev);
          let alertInfo = ev.data.split(",")[1];
          this.$notify({
            title: '离床告警',
            message: alertInfo,
            duration: 60 * 1000,
            type: 'warning'
          });
        }
      }
    },
    //发送信息时
    websocketsend(Data) {
      //数据发送
      this.websock.send(Data);
    }
  },
  mounted() {
    let outjumpFlag = sessionStorage.getItem("outjump");
    if (outjumpFlag && outjumpFlag == 'true') {
    }else{
      this.getToken();
    }
  },
  destroyed() {
    if (this.interval != null) {
      window.clearInterval(this.interval)
    }
    if (this.alertInterval != null) {
      window.clearInterval(this.alertInterval)
    }
    if(this.webSocketInterval !=null){
      window.clearInterval(this.webSocketInterval)
    }
    sessionStorage.removeItem("userId"); //销毁userId
    this.userId = null;
  },
  created() {
    this.interval = setInterval(() => {
      this.getToken();
    }, 30 * 60 * 1000);
    bus.$on('collapse-content', msg => {
      this.collapse = msg;
    });
    //接收子界面发送的eventBus消息,进行判断消息跳转等操作
    bus.$on("homePage", (msg) => {
      this.geteventBusMshJump(msg);
    });
    // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
    bus.$on('tags', msg => {
      let arr = [];
      for (let i = 0, len = msg.length; i < len; i++) {
        msg[i].name && arr.push(msg[i].name);
      }
      this.tagsList = arr;
    });
    //从admin 页面跳转进来的
    let outjumpFlag = sessionStorage.getItem("outjump");
    if (outjumpFlag && outjumpFlag == 'true') {
      this.loading = true;
      this.getAdminToken();
      sessionStorage.setItem(
        "user",
        window.sessionStorage.getItem("username")
      );
      setTimeout(() => {
        this.getUserData();
        this.getAlarmlogDetail();
        sessionStorage.removeItem("outjump");
      }, 1500)
      setTimeout(() => {
        this.loading = false;
      }, 2500)
      return;
    }
    this.groupId = sessionStorage.getItem("groupId");
    this.roleCode = sessionStorage.getItem("roleCode");
    this.getUserData();
    this.getAlarmlogDetail();
  }
};
</script>
<style>
.el-button--small {
  font-size: 15px;
}

.el-table--small {
  font-size: 14px;
}

.el-submenu__title i {
  color: #ffffff;
  right: 10px;
}

.el-tooltip__popper {
  max-width: 60%
}
</style>